import React from "react";
import direction from "../../../service/direction.json";
const DescriptionReseller2 = () => {
  return (
    <div className="form-group row col-md-12 text-justify">
      <div className="col-md-8">
        بعد از اینکه مطلب فوق را مطالعه کردید الان میتوانید درک بهتری از درآمد
        نمایندگان در سرویس تلفن ثابت ابری داشته باشید. درآمد نماینده از فروش
        تلفن ثابت اینترنتی در سه قسمت است:
        <ol type="1">
          <li>
            <span className="text-bold">پورسانت فروش خط تلفن ابری:</span>
            ما برای نمایندگان هزینه خرید خط تلفن ابری را با 10درصد تخفیف لحاظ
            کرده ایم. یعنی در جشنواره فعلی بجای 100 هزارتومان، 90 هزارتومان که
            اختلاف این مبلغ سود فروش خط میباشد.
          </li>
          <br />
          <li>
            <span className="text-bold">سود هزینه فعالسازی خط: </span>
            همانطور که در توضیحات تلفن ابری اعلام شد موقع خرید خط مبلغ 50
            هزارتومان هزینه فعالسازی به هزینه خرید خط کاربرانمان اضافه میکنیم که
            این هزینه را برای نمایندگان 35 هزارتومان لحاظ کرده ایم و نماینده
            میتواند این مبلغ را برای زیرمجموعه خودش هر مبلغ بالای 50 هزارتومان
            تنظیم کند. مثلا هزینه فعالسازی را 80 هزارتومان تعیین کند و از هر خط
            45 هزارتومان سود در هزینه فعالسازی داشته باشد.
          </li>
          <br />
          <li>
            <span className="text-bold">سود ماهانه سرویس هاستد: </span>
            با توجه به اینکه خط تلفن ابری دائمی و بدون نیاز به تمدید میباشد و
            فعالسازی آن نیز یکبار انجام میشود، پس شما در مورد اول و دوم (خرید و
            فعالسازی خط ابری) یکبار سود میکنید. ولی سود حاصل از خرید سرویس هاستد
            ماهانه میباشد. هزینه سرویس هاستد برای نماینده ماهانه 64900 تومان
            میباشد که میتوانید این مبلغ را برای کاربرانتان هر مبلغ دلخواهی بالای
            80 هزارتومان تنظیم کنید. مثلا اگر 100 هزارتومان تنظیم کنید از هر
            کاربری که سرویس هاستد خریداری کند ماهانه در حدود 35 هزارتومان سود
            خواهید کرد. باتوجه به اینکه سود حاصل از سرویس هاستد ماهانه میباشد،
            این مورد میتواند درآمد اصلی شما را تشکیل دهد.
          </li>
        </ol>
      </div>
      <div className="col-md-4 text-center">
        <img
          src={`${direction.ImgDesign}cloud-fon-priceing.png`}
          alt="سایه بان"
        />
      </div>
    </div>
  );
};

export default DescriptionReseller2;
